module.exports = __webpack_public_path__ + "static/media/logo.46ac4c24.jpg";